import { FileLog } from "../context/helper";
import { useState, useEffect, useCallback} from "react";
import { StyleSheet, Text } from "react-native";
import SafeAreaView from "../components/SafeAreaView";
import PageHeader from "../components/PageHeader";
import { ScrollView, RefreshControl } from "react-native-gesture-handler";
import CustomButton from "../components/CustomButton";
import ActivityScreen from "./activityscreen";

const LogScreen = ({ navigation }) => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [logData, setLogData] = useState("");
  const [refreshing, setRefreshing] = useState(false);

  const LoadData = async (dorefresh) => {
    dorefresh ? setRefreshing(true) : setDataLoaded(false);
    setLogData(await FileLog.load());
    dorefresh ? setRefreshing(false) : setDataLoaded(true);
  };

  const onRefresh = useCallback(() => {
    LoadData(true);
  }, []);

  useEffect(() => {
    LoadData(false);
  }, []);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={styles.mainContainer}>
      <PageHeader navigation={navigation} showBack={true} />
      <ScrollView
        style={styles.scrollContainer}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      >
        <Text>{logData.length > 0 ? logData : "Log is empty"}</Text>
      </ScrollView>
      <CustomButton
        style={styles.clearButton}
        onPress={async () => {
          await FileLog.clear();
          LoadData(false);
        }}
      >
        Clear
      </CustomButton>
    </SafeAreaView>
  );
};

export default LogScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: "#fff",
    paddingTop: 20,
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
  clearButton: {
    marginHorizontal: 10,
    marginTop: 10,
  },
});
